import RequestApi from "../../modules/requestApi";
import config from "../../../config.js";
import { encode as base64Encode } from "js-base64";

/**
 * Состояния и методы, связанные со страницами авторизации
 */
const state = {};

const mutations = {};

const actions = {
  /**
   * Создание скриншотов wifi-авторизации для preview темы / рекламы
   * params.pages - массив с названиями страниц wifi-авторизации
   * params.theme_id - id темы
   * params.advertising_id - id рекламы
   */
  setWifiAuthScreenshotes(context, params) {
    let items = {},
      // ключ в массиве, зависит от page и size
      resultKey,
      // полный путь к файлу
      resultUrl;

    return new Promise((resolve, reject) => {
      // в цикле создает скриншоты,
      // возвращает массив из url скриншотов
      Promise.all(
        params.pages.map((page) => {
          return new Promise((resolve, reject) => {
            let name = "",
              urlParams = {};
            // формируем ссылку и имя файла от параметров
            if (params.theme_id) {
              urlParams.theme_id = params.theme_id;
              name = `theme${params.theme_id}_`;
            }
            if (params.size) {
              name += `${params.size}_`;
            }
            if (params.poll_id && page === "poll") {
              urlParams.id = params.poll_id;
              name += `${params.poll_id}_addPage.png`;
            } else if (params.advertising_id && page === "advertising") {
              urlParams.id = params.advertising_id;
              name += `${params.advertising_id}_addPage.png`;
            } else {
              name += `${page}.png`;
            }
            RequestApi.screenshot({
              url: `${config.urlWifiAuth}/${page}/?params=${base64Encode(
                JSON.stringify(urlParams)
              )}`,
              name: name,
              size: params.size,
            })
              .then((data) => {
                resolve({ path: data.path, name: page });
              })
              .catch(reject);
          });
        })
      )
        .then((values) => {
          values.forEach((item) => {
            resultKey =
              item.name +
              (params.size && params.size !== "xs" ? params.size : "");
            resultUrl = `${item.path}?tm=${new Date().getTime()}`;
            items[resultKey] = resultUrl;
          });

          resolve(items);
        })
        .catch(reject);
    });
  },
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters,
};
